import * as React from 'react';
import { Input } from '../../../ui/input';
import { cn } from '../../../../lib/utils';

export interface DocumentInputProps
    extends React.InputHTMLAttributes<HTMLInputElement> {}

export const DocumentInput = React.forwardRef<
    HTMLInputElement,
    DocumentInputProps
>(({ className, type, ...props }, ref) => {
    return <Input type={type} className={cn(className)} ref={ref} {...props} />;
});
DocumentInput.displayName = 'DocumentInput';
